import { css } from '@/styled-system/css';

export const trigger = css.raw({
  display: 'block',
  width: '100%',
  height: '100%',
  padding: 'zero',
  border: 'none',
  borderRadius: 'md',
  overflow: 'hidden',
  background: 'none',
  cursor: 'pointer',
  _focusVisible: {
    outline: 'none',
    boxShadow: 'focus',
  },
});
